export const APP_HEADERS = {
  "x-app-version": typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0',
  "x-app-platform": "web",
} as const;
